import { cn } from '#app/utils/misc.tsx'
import { Icon, IconName } from '../icon.tsx'

export type IUSPBannerItem = {
	iconName: IconName
	text: string
	animate?: boolean
	index: number
}

const USPBannerItem: React.FC<IUSPBannerItem> = ({
	iconName,
	text,
	animate,
	index,
}) => {
	const animationClassName =
		'animate animate-[slideAnimation_3s_ease-in-out' +
		(index ? `_${index * 3}s` : '') +
		']'
	return (
		<div
			className={cn(
				`header-top__content col slide--${index + 1}`,
				animate && animationClassName,
			)}
		>
			<Icon
				name={iconName}
				className="h-6 w-6"
				stroke="currentColor"
				strokeWidth={1.5}
			/>
			&nbsp;{text}
		</div>
	)
}

export { USPBannerItem }
